/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2023-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React, { Component } from "react";
import {
  ComposedModal,
  InlineNotification,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "carbon-components-react";
import { AppMsg } from "../utils";
import {
  Form,
  TextInput,
  UnorderedList,
  ListItem,
} from "carbon-addons-iot-react";
import { ChangePasswordService } from "../services/ChangePasswordService";
import { createPortal } from "react-dom";
import "./ChangePasswordModal.scss";

const cssBase = "change-password-modal";
const BLANK = "";

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: BLANK,
      confirmNewPassword: BLANK,
      currentPassword: BLANK,
      errorMessage: BLANK,
      errorMessageTitle: BLANK,
      disableContinue: true,
      isPasswordRulesNotMet: false,
      isNoPasswordMatch: false,
      isInvalidCurrentPassword: false,
      username: this.props.username,
    };
  }

  _setNewPassword(pwd) {
    this.setState(
      {
        newPassword: pwd,
      },
      () => {
        this._validateInputFields();
      }
    );
  }

  _setConfirmNewPassword(pwd) {
    this.setState(
      {
        confirmNewPassword: pwd,
      },
      () => {
        this._validateInputFields();
      }
    );
  }

  _setCurrentPassword(pwd) {
    this.setState(
      {
        currentPassword: pwd,
      },
      () => {
        this._validateInputFields();
      }
    );
  }

  _validateInputFields() {
    const { currentPassword, newPassword, confirmNewPassword, errorMessage } =
      this.state;

    if (
      currentPassword !== BLANK &&
      newPassword !== BLANK &&
      confirmNewPassword !== BLANK &&
      newPassword === confirmNewPassword &&
      errorMessage === BLANK
    ) {
      this.setState({
        disableContinue: false,
        isNoPasswordMatch: false,
        isPasswordRulesNotMet: false,
        isInvalidCurrentPassword: false,
      });
    } else {
      if (
        newPassword !== BLANK &&
        confirmNewPassword !== BLANK &&
        newPassword !== confirmNewPassword
      ) {
        this.setState({
          isNoPasswordMatch: true,
          disableContinue: true,
          isPasswordRulesNotMet: false,
          isInvalidCurrentPassword: false,
        });
      } else {
        this.setState({
          isNoPasswordMatch: false,
          disableContinue: true,
          isPasswordRulesNotMet: false,
          isInvalidCurrentPassword: false,
        });
      }
    }
  }

  _enableContinueButton() {
    this.setState(
      {
        errorMessage: BLANK,
        errorMessageTitle: BLANK,
      },
      () => {
        this._validateInputFields();
      }
    );
  }

  handleSubmit(event) {
    const { username, currentPassword, newPassword, confirmNewPassword } =
      this.state;
    event.preventDefault();

    ChangePasswordService.changePassword(
      username,
      currentPassword,
      newPassword,
      confirmNewPassword
    ).then(
      () => {
        this.props.showPasswordChangedSuccessfully();
      },
      (error) => {
        this._handleChangePwdError(error);
      }
    );
  }

  _handleChangePwdError(error) {
    if (error && error.includes("Invalid username or password")) {
      this.setState({
        isPasswordRulesNotMet: false,
        isInvalidCurrentPassword: true,
        disableContinue: true,
      });
    } else if (
      error &&
      error.includes("Password does not meet the required criteria")
    ) {
      this.setState({
        isPasswordRulesNotMet: true,
        isInvalidCurrentPassword: false,
        disableContinue: true,
      });
    } else {
      this.setState({
        isPasswordRulesNotMet: false,
        errorMessage: AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR_PWD),
        errorMessageTitle: AppMsg.getMessage(AppMsg.APP_ERROR),
        disableContinue: true,
      });
    }
  }

  _getPasswordRulesDisplay = () => {
    const { passwordRules } = this.props;

    const customRulesListItems = this.props.customPasswordRules.map(
      (rule, index) => <ListItem key={index}>{rule}</ListItem>
    );

    return (
        <>
          {passwordRules.triEnforcePasswordRulesBL === "true" ? (
            <>
              <div style={{ margin: "0px", marginTop: "20px", marginBottom: "-11px" }}>
                <label style={{ fontSize: "12px" }}>
                  {AppMsg.getMessage(AppMsg.APP_PWD_RULES_CONSIST_OF)}
                </label>
              </div>
              <div
                style={{
                  margin: "17px",
                  marginTop: "15px",
                  marginBottom: "-15px",
                }}
              >
                <UnorderedList style={{ fontSize: "12px" }}>       
                  <ListItem>
                    {this._getMinMaxCharacterMessage(passwordRules)}
                  </ListItem>
                  <>{Number(passwordRules.triHistPwdCountLI) > 1 ? 
                      <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_HISTORY_COUNT).replace("{1}", passwordRules.triHistPwdCountLI)}</ListItem>: 
                      <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_HISTORY_PREVIOUS)}</ListItem>}</>
                  <>
                    {passwordRules.triNumbersReqLI === "Required" ? (
                      <ListItem>
                        {AppMsg.getMessage(AppMsg.APP_PWD_RULE_NUMBER_REQ)}
                      </ListItem>
                    ) : (
                      BLANK
                    )}
                  </>
                  <>
                    {passwordRules.triLowercaseReqLI === "Required" ? (
                      <ListItem>
                        {AppMsg.getMessage(AppMsg.APP_PWD_RULE_LOWERCASE_REQ)}
                      </ListItem>
                    ) : (
                      BLANK
                    )}
                  </>
                  <>
                    {passwordRules.triUppercaseReqLI === "Required" ? (
                      <ListItem>
                        {AppMsg.getMessage(AppMsg.APP_PWD_RULE_UPPERCASE_REQ)}
                      </ListItem>
                    ) : (
                      BLANK
                    )}
                  </>
                  <>
                    {passwordRules.triSpecialCharactersReqLI === "Required" ? (
                      <ListItem>
                        {AppMsg.getMessage(AppMsg.APP_PWD_RULE_SPECIAL_REQ)}
                      </ListItem>
                    ) : (
                      BLANK
                    )}
                  </>
                  <><ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NOT_CONTAIN_USERNAME)}</ListItem></>
                  <>{customRulesListItems}</>
                </UnorderedList>
              </div>
              <>{this._getPasswordOptionalRulesDisplay()}</>
            </>
          ) : (
            <div style={{margin:"0px", marginTop:"15px", marginBottom:"-15px"}}>
                <label style={{fontSize:"12px"}}>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NOT_SAME_AS_PREVIOUS)}</label>
            </div>
          )}
        </>
    );
  };

  _getMinMaxCharacterMessage(passwordRules) {
    let message = AppMsg.getMessage(AppMsg.APP_PWD_RULE_MIN_MAX_CHARS).replace("{1}", passwordRules.triMinPwdLengthNU);
    return message.replace("{2}", passwordRules.triMaxPwdLengthNU);
  }

  _getPasswordOptionalRulesDisplay() {
    const { passwordRules } = this.props;
    let minOptionalRulesReq = Number(passwordRules.triMinOptionalReqsNU);
    if (minOptionalRulesReq > 0) {
      let actualOptionalRulesCount = 0;
      if (passwordRules.triLowercaseReqLI === "Optional") {
        actualOptionalRulesCount++;
      }
      if (passwordRules.triUppercaseReqLI === "Optional") {
        actualOptionalRulesCount++;
      }
      if (passwordRules.triNumbersReqLI === "Optional") {
        actualOptionalRulesCount++;
      }
      if (passwordRules.triSpecialCharactersReqLI === "Optional") {
        actualOptionalRulesCount++;
      }
      if (actualOptionalRulesCount < minOptionalRulesReq) {
        minOptionalRulesReq = actualOptionalRulesCount;
      }
      return actualOptionalRulesCount > 0 ? (
        <>
          <div
            style={{ margin: "0px", marginTop: "20px", marginBottom: "-11px" }}
          >
            <label style={{ fontSize: "12px" }}>
              {AppMsg.getMessage(
                AppMsg.APP_PWD_RULES_OPTIONAL_CONSIST_OF
              ).replace("{1}", minOptionalRulesReq)}
            </label>
          </div>
          <div
            style={{ margin: "17px", marginTop: "15px", marginBottom: "-15px" }}
          >
            <UnorderedList style={{ fontSize: "12px" }}>
              <>
                {passwordRules.triNumbersReqLI === "Optional" ? (
                  <ListItem>
                    {AppMsg.getMessage(AppMsg.APP_PWD_RULE_NUMBER_OPTIONAL)}
                  </ListItem>
                ) : (
                  BLANK
                )}
              </>
              <>
                {passwordRules.triLowercaseReqLI === "Optional" ? (
                  <ListItem>
                    {AppMsg.getMessage(AppMsg.APP_PWD_RULE_LOWERCASE_OPTIONAL)}
                  </ListItem>
                ) : (
                  BLANK
                )}
              </>
              <>
                {passwordRules.triUppercaseReqLI === "Optional" ? (
                  <ListItem>
                    {AppMsg.getMessage(AppMsg.APP_PWD_RULE_UPPERCASE_OPTIONAL)}
                  </ListItem>
                ) : (
                  BLANK
                )}
              </>
              <>
                {passwordRules.triSpecialCharactersReqLI === "Optional" ? (
                  <ListItem>
                    {AppMsg.getMessage(AppMsg.APP_PWD_RULE_SPECIAL_OPTIONAL)}
                  </ListItem>
                ) : (
                  BLANK
                )}
              </>
            </UnorderedList>
          </div>
        </>
      ) : (
        BLANK
      );
    }
  }

  _handleCloseButton = () => {
    this.props.handleCloseButton();
  };

  _handleSpaceEntry(e) {
    //If keyCode is a space (32), stop propagation in order to allow space entry.
    if (e.keyCode === 32) {
      e.stopPropagation();
    }
  }

  render() {
    const {
      errorMessage,
      errorMessageTitle,
      isPasswordRulesNotMet,
      newPassword,
      isNoPasswordMatch,
      confirmNewPassword,
      disableContinue,
      isInvalidCurrentPassword,
    } = this.state;
    return (
      <>
        {createPortal(
          <ComposedModal
            size="sm"
            preventCloseOnClickOutside={true}
            passiveModal
            onClose={this._handleCloseButton}
            iconDescription={AppMsg.getMessage(AppMsg.CLOSE)}
            open
            type="normal"
            className={`${cssBase}--container`}
          >
            <ModalHeader>
              {AppMsg.getMessage(AppMsg.CREATE_NEW_PASSWORD)}
            </ModalHeader>
            <ModalBody hasForm>
              <div className={`${cssBase}--login-main-wrapper`}>
                {errorMessage ? (
                  <div className={`${cssBase}--tri-inline-notification-div`}>
                    <InlineNotification
                      hideCloseButton={false}
                      iconDescription="close"
                      kind="error"
                      notificationType="toast"
                      onCloseButtonClick={() => this._enableContinueButton()}
                      role="alert"
                      statusIconDescription={BLANK}
                      subtitle={errorMessage}
                      title={errorMessageTitle}
                    />
                  </div>
                ) : (
                  BLANK
                )}
                <Form>
                  <div className={`${cssBase}--current-password-input-form`}>
                    <TextInput.PasswordInput
                      labelText={AppMsg.getMessage(AppMsg.APP_CURRENT_PASSWORD)}
                      id="currentPassword"
                      placeholder={AppMsg.getMessage(
                        AppMsg.APP_ENTER_CURRENT_PASSWORD
                      )}
                      type="password"
                      invalid={isInvalidCurrentPassword}
                      invalidText={AppMsg.getMessage(
                        AppMsg.APP_CURRENT_PASSWORD_ERROR
                      )}
                      onChange={(e) => this._setCurrentPassword(e.target.value)}
                      onKeyDown={(e) => this._handleSpaceEntry(e)}
                      value={this.state.currentPassword}
                    />
                  </div>
                  <div className={`${cssBase}--new-password-input-form`}>
                    <TextInput.PasswordInput
                      labelText={AppMsg.getMessage(AppMsg.APP_NEW_PASSWORD)}
                      id="newPassword"
                      placeholder={AppMsg.getMessage(
                        AppMsg.APP_ENTER_NEW_PASSWORD
                      )}
                      type="password"
                      invalid={isPasswordRulesNotMet}
                      invalidText={AppMsg.getMessage(
                        AppMsg.APP_ERROR_PASSWORD_RULES_NOT_MET
                      )}
                      onChange={(e) => this._setNewPassword(e.target.value)}
                      onKeyDown={(e) => this._handleSpaceEntry(e)}
                      value={newPassword}
                    />
                  </div>
                  <div
                    className={`${cssBase}--confirm-new-password-input-form`}
                  >
                    <TextInput.PasswordInput
                      labelText={AppMsg.getMessage(
                        AppMsg.APP_CONFIRM_NEW_PASSWORD
                      )}
                      id="confirmNewPassword"
                      placeholder={AppMsg.getMessage(
                        AppMsg.APP_ENTER_CONFIRM_NEW_PASSWORD
                      )}
                      type="password"
                      invalid={isNoPasswordMatch}
                      invalidText={AppMsg.getMessage(
                        AppMsg.APP_ERROR_NEW_PASSWORD_NO_MATCH
                      )}
                      onChange={(e) =>
                        this._setConfirmNewPassword(e.target.value)
                      }
                      onKeyDown={(e) => this._handleSpaceEntry(e)}
                      value={confirmNewPassword}
                    />
                  </div>
                  {this._getPasswordRulesDisplay()}
                </Form>
              </div>
            </ModalBody>
            <ModalFooter
              primaryButtonText={AppMsg.getMessage(AppMsg.APP_CONTINUE)}
              primaryButtonDisabled={disableContinue}
              onRequestSubmit={(e) => {
                this.handleSubmit(e);
              }}
              secondaryButtonText={AppMsg.getMessage(AppMsg.APP_CANCEL)}
              onRequestClose={this._handleCloseButton}
            ></ModalFooter>
          </ComposedModal>,
          document.body
        )}
      </>
    );
  }
}

export default ChangePasswordModal;
